// src/autoUpdate.ts
// ============================================================================
// AUTO-ACTUALIZACIÓN DEL PANEL (sin botón)
// ============================================================================
// El manager NO es PWA, así que detectamos nuevas versiones comparando el hash
// del bundle en el index.html (servido con no-store, siempre fresco) contra el
// que tenemos cargado. Si cambió → recarga limpia. Se chequea al volver a la
// pestaña y cada pocos minutos.
//
// Liviano: cada chequeo re-pide el index.html (~3 KB). No re-descarga la app.
// Mismo comportamiento que el auto-update del kiosko (app.lealify) y del Club
// de Lectura: la pestaña se actualiza sola sin que el usuario haga nada.
// ============================================================================

const CHECK_MS = 120000; // 2 min (ajustable). El chequeo al enfocar la pestaña lo hace responsivo.

function currentBundle(): string | null {
  const s = document.querySelector('script[type="module"][src*="/assets/index-"]') as HTMLScriptElement | null;
  return s ? s.getAttribute('src') : null;
}

export function initAutoUpdate(): void {
  const loaded = currentBundle();
  if (!loaded) return; // dev o estructura inesperada → no hacer nada

  let reloading = false;
  const check = async () => {
    if (reloading || document.visibilityState !== 'visible') return;
    try {
      const html = await fetch('/?_=' + Date.now(), { cache: 'no-store' }).then((r) => r.text());
      const m = html.match(/\/assets\/index-[A-Za-z0-9_-]+\.js/);
      if (m && m[0] !== loaded) {
        reloading = true;
        // Limpiar caches por si acaso y recargar limpio
        if ('caches' in window) {
          try {
            const ks = await caches.keys();
            await Promise.all(ks.map((k) => caches.delete(k)));
          } catch { /* ignore */ }
        }
        window.location.reload();
      }
    } catch {
      /* sin red: reintentar en el próximo ciclo */
    }
  };

  document.addEventListener('visibilitychange', check);
  setInterval(check, CHECK_MS);
}
